module.exports = __webpack_public_path__ + "static/img/card_icon_delete@2x.647ca9af.png";